<template>
  <div class="content">
    <div class="content-top">
      <el-form :model="answerExamParms" ref="answerForm" :inline="true" class="content-top-form">
        <el-form-item label="问卷名称：">
          <el-input
            v-model="answerExamParms.paperName"
            placeholder="请输入部门名称">
          </el-input>
        </el-form-item>
        <el-form-item label="添加时间：">
            <el-date-picker
              v-model="answerExamParms.createTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开通时间"
              end-placeholder="到期时间"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
        </el-form-item>
        <el-form-item label="添加人：">
          <el-input
            v-model="answerExamParms.realName"
            placeholder="请输入添加人">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" @click.stop="handleQuery">查询</el-button>
          <el-button icon="el-icon-refresh" @click.stop="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 操作按钮 -->
    <div class="operaBtn">
      <el-button @click="handleInsertAnswerExam">
        <i class="el-icon-circle-plus-outline"></i>新增
      </el-button>
    </div>

    <!-- 表格内容 -->
    <sys-table ref="sysTable"
                   :tableList="answerExamtList"
                   rowKey="id"
                   :showIndex="true"
                   operationWidth="200px"
                   :columList="answerColumList"
                   v-loading="isLoading"
                   @handlerElSwitch="handlerElSwitch"
                   @openUrlCode="openUrlCode">
      <template #slotButton="slotProps">
        <el-button type="text" size="medium" @click.stop="handlerSubmitUserDetail(slotProps.rowData)">提交详情</el-button>
        <el-button type="text" size="medium" @click.stop="handlerSeeExamDetail(slotProps.rowData)">查看</el-button>
        <el-button type="text" size="medium" @click.stop="handlerEditExamDetail(slotProps.rowData)">编辑</el-button>
        <el-button type="text" size="medium" @click.stop="handlerDelExamDetail(slotProps.rowData)">删除</el-button>
      </template>
    </sys-table>

    <!-- 查看题目详情弹框 -->
    <sys-dialog
        :title="messageDialog.title"
        :width="messageDialog.width"
        :height="messageDialog.height"
        :visible="messageDialog.visible"
        :isShowCancle="messageDialog.isShowCancle"
        @onConfirm="messageConfirm"
        @onClose="messageClose">
      <div slot="content" class="message-text">
        <answer-exam-detail :answerExamtPaperTests="answerExamtPaperTests" :rowExamName="rowExamName"></answer-exam-detail>
      </div>
    </sys-dialog>

    <!-- 查看题目详情弹框 -->
    <sys-dialog
      :title="urlCodeDialog.title"
      :width="urlCodeDialog.width"
      :height="urlCodeDialog.height"
      :visible="urlCodeDialog.visible"
      :isShowCancle="urlCodeDialog.isShowCancle"
      @onConfirm="urlCodeConfirm"
      @onClose="urlCodeClose">
      <div slot="content" class="message-text-urlcode">
        <div class="dialogUrlCode">
          <vueqr :text="urlConfig.value" :logoSrc="urlConfig.imagePath" :size="300" ref="urlCode"></vueqr>
          <p class="dialogUrlCode_bak">注: 扫描图中二维码进行问卷调查！</p>
        </div>
      </div>
    </sys-dialog>

    <!-- 分页 -->
    <div class="footBox">
      <div class="footPage">
        <p>
          共有{{ pageParms.total }}条记录
        </p>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageParms.currentPage"
          :page-size="pageParms.pageSize"
          :page-sizes="pageParms.pagesizesArr"
          layout="prev, pager, next, sizes, jumper"
          :total="pageParms.total"
          class="pagination">
        </el-pagination>
      </div>
    </div>


  </div>
</template>

<script>
import $answer from "@/api/answerExam.js";
import SysTable from "@/components/system/SysTable";
import SysDialog from "@/components/system/SysDialog";
import AnswerExamDetail from "@/components/answerExam/AnswerExamDetail";
import vueqr from "vue-qr";
export default {
  props: ["changes"],
  components: {
    SysTable,
    SysDialog,
    AnswerExamDetail,
    vueqr
  },
  data() {
    return {
      answerExamParms:{
        paperName:"",
        createTime:[],
        realName:""
      },
      isLoading: false,
      // 考生列表数据
      answerExamtList: [],
      pageParms:{
        // 当前页
        currentPage: 1,
        pageSize: 10,
        pagesizesArr: [5, 10, 20, 50, 100],
        // 总数量
        total: 100,
      },
      answerColumList:[
        {
          prop: "paper_name",
          lable: "问卷名称",
          width:"",
          align:"center",
        },
        {
          prop: "is_show",
          lable: "是否显示",
          width:"",
          align:"center",
          type:"elSwitch"
        },
        {
          prop: "url_code",
          lable: "二维码",
          width:"",
          align:"center",
          type:"urlCode"
        },
        {
          prop: "personSum",
          lable: "提交人数",
          width:"",
          align:"center"
        },
        {
          prop: "create_time",
          lable: "添加时间",
          width:"",
          align:"center",
          type:"dateHHmm",
        },
        {
          prop: "realName",
          lable: "添加人",
          width:"",
          align:"center",
        },
      ],
      rowExamId:"",
      messageDialog:{
        title:"问卷详情",
        width:600,
        height:700,
        visible:false,
      },
      urlCodeDialog:{
        title:"问卷二维码",
        width:400,
        height:380,
        visible:false,
      },
      urlConfig: {
        //二维码内的信息
        imagePath: require("../../../assets/yunlogo.png"), //中间logo的地址
        value: "", //显示的值、跳转的地址
      },
      answerExamtPaperTests:[],
      rowExamName:""
    };
  },
  methods: {
    urlCodeConfirm:function(){
      this.urlCodeDialog.visible = false;
    },
    urlCodeClose:function(){
      this.urlCodeDialog.visible = false;
    },
    openUrlCode:function(row){
      this.urlCodeDialog.visible = true;
      this.urlConfig.value = row.url_code;
      console.log("=================openUrlCode",row);
    },
    handlerElSwitch:function(row){
      let that = this;
      let message = "";
      if(row.is_show == 0){
        message = "是否关闭该问卷调查？"
      }else{
        message = "是否开启该问卷调查？"
      }
      this.$confirm(message, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const parms = {};
        that.UtilFun(parms);
        parms.examId = row.id;
        parms.is_show = row.is_show;
        const { data } = $answer.updateAnswerExamIsShow(parms).then(res =>{
          let result = res.data;
          if (result.Status === 200) {
            that.isLoading = false;
            that.$message.success("操作成功！");
          } else {
            row.is_show = row.is_show == 1 ? '0':'1';
            that.$message.error("操作失败！");
          }
        }).catch(err =>{
          row.is_show = row.is_show == 1 ? '0':'1';
          that.$message.error("操作失败！");
        });
      }).catch(() => {
        row.is_show = row.is_show == 1 ? '0':'1';
        setTimeout(() => {
          that.$message.info('已取消操作!');
        }, 200);
      });
    },
    resetForm:function(){
      //清空表单
      this.$utils.resetForm("answerForm",this.answerExamParms,this);
    },
    getAnswerExamList:async function(){
      this.isLoading = true;
      const parms = {};
      this.UtilFun(parms);
      parms.pageIndex = this.pageParms.currentPage - 1;
      parms.pageShow = this.pageParms.pageSize;
      parms.paperName = this.answerExamParms.paperName;
      parms.realName = this.answerExamParms.realName;
      if(this.answerExamParms.createTime.length > 0){
        parms.beginTime = this.$moment(this.answerExamParms.createTime[0]).format("YYYY-MM-DD HH:mm:ss");
        parms.endTime = this.$moment(this.answerExamParms.createTime[1]).format("YYYY-MM-DD HH:mm:ss");
      }
      const { data } = await $answer.getAnswerExamList(parms);
      if (data.Status === 200) {
        this.answerExamtList = data.Data.data;
        this.pageParms.total = data.Data.count;
      } else {
        this.$message.error("获取考生信息失败！");
      }
      setTimeout(() => {
        this.isLoading = false;
      }, 200);
    },
    handleInsertAnswerExam:function(){
      this.rowExamId = "";
      this.rowExamName = "";
      this.changes(1);
    },
    handlerSeeExamDetail:async function(row){
      this.isLoading = true;
      const parms = {};
      this.UtilFun(parms);
      parms.examId = row.id;
      const { data } = await $answer.getAnswerExamPaperTest(parms);
      if (data.Status === 200) {
        this.rowExamName = row.paper_name;
        this.answerExamtPaperTests = data.Data;
        this.messageDialog.visible = true;
      } else {
        this.$message.error("获取调查问卷题目失败！");
      }
      this.isLoading = false
    },
    handlerEditExamDetail:function(row){
      console.log("111",row.personSum)
      if(row.personSum > 0){
        this.$message.error("当前已有用户填写问卷，不能编辑！");
      }else{
        this.rowExamId = row.id;
        this.rowExamName = row.paper_name;
        this.changes(1);
      }
    },
    handlerDelExamDetail:function(row){
      let that = this;
      this.$confirm('此操作将永久删除该问卷, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.isLoading = true;
        const parms = {};
        that.UtilFun(parms);
        parms.examId = row.id;
        $answer.deleteAnswerExam(parms).then(res =>{
          let result = res.data;
          if (result.Status === 200) {
            this.isLoading = false;
            this.$message.success("删除调查问卷成功！");
            this.getAnswerExamList();
          } else {
            this.isLoading = false;
            this.$message.error("删除调查问卷失败！");
          }
        }).catch(err =>{
          this.isLoading = false;
          this.$message.error("删除调查问卷失败！");
        });
      }).catch(() => {
        setTimeout(() => {
          this.$message.info('已取消删除!');
        }, 200);
      });
    },
    //查询
    handleQuery:function(){
      this.getAnswerExamList();
    },
    handlerSubmitUserDetail:function(row){
      console.log("=2222========",row);
      this.rowExamId = row.id;
      this.rowExamName = row.paper_name;
      this.changes(2);
    },
    messageConfirm:function(){
      this.messageDialog.visible = false;
    },
    messageClose:function(){
      this.messageDialog.visible = false;
    },
    // 显示条数
    handleSizeChange:function(val) {
      // 改变每页显示条数的时候调用一次
      this.pageParms.currentPage = 1;
      this.pageParms.pageSize = val;
      this.getAnswerExamList();
      console.log(`每页 ${val} 条`);
    },
    // 分页
    handleCurrentChange:function(val) {
      console.log(`当前页: ${val}`);
      this.pageParms.currentPage = val;
      this.getAnswerExamList();
    },
    // 封装方法
    UtilFun:function(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },
  },
  //被keep-alive组件包裹时使用
  activated() {
    console.log("执行了answerExamPage")
    this.getAnswerExamList();
  },
};
</script>

<style lang="scss" scoped>
.message-text-urlcode{
  display: flex;
  justify-content: center;
  .dialogUrlCode_bak{
    margin-top: 30px;
    text-align: center;
    font-size: 20px;
    color: red;
  }
}
.content {
  height: 100%;
  width: 100%;
  padding: 0px 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
  .content-top{
    ::v-deep .el-form-item__label{
      font-size: 15px;
      font-weight: 400;
      color: #333333;
    }
    ::v-deep .el-form-item{
      margin-right: 30px;
    }
    ::v-deep .el-input{
      width: 200px;
    }
    padding-top: 24px;
  }
}

.operaBtn {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 849px;
  height: 40px;
  opacity: 1;
  .el-button + .el-button {
    margin-left: 24px;
  }
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
    width: 114px;
  }
}


.footBox {
  position: relative;
  height: 110px;
  .footPage {
    align-items: center;
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;

    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
  }
  .pagination {
    ::v-deep .el-pager {
      li {
        border: 1px solid #d9d9d9;
        margin-right: 8px;
        &.active {
          color: #ffffff;
          background-color: #409eff;
          border: none;
        }
      }
    }
    ::v-deep .el-pagination__jump {
      margin: 0px 10px 0px 0px !important;
    }
  }
}

.message-text{
  display: flex;
  i {
    font-size: 16px;
    color: #ffc664;
    margin-right: 10px;
    transform: translateY(4px);
  }
  p {
    text-align: left;
    font-size: 15px;
    font-weight: 400;
    line-height: 26px;
    color: #333333;
    opacity: 1;
  }
}
</style>
